/**
 * オリジナルデザイン（OD）の詳細ページ（single-od.php）
 * MEMO: 旧 js/od-single.js の ESM 版（ページ表示後にローダーを消し、OD アプリへの遷移を初期化）
 *       旧版のログイン確認は、開発サイト（dev）で API のホストが決まらず失敗していた（utils/auth.ts の fetchProfile() で修正）
 */
import { onReady } from '@/utils/dom'
import { fadeOut } from '@/utils/fade'
import { initOdDesignForm } from '@/utils/od-design'

onReady(() => {
    const loader = document.getElementById('od-page-loader')
    if(loader) fadeOut(loader)
    initOdDesignForm({ checkLogin: true })
})
